module.exports = __webpack_public_path__ + "imgcvh/hero-7.f005e836.jpg";